import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const Line = styled.div`
  margin-top: ${({ theme }) => theme.spacings[1]};
  height: ${({ theme, lightLine }) => (lightLine ? '0.25rem' : theme.spacings[1])};
  background: ${({ theme, color = 'pink' }) => theme.colors[color]};
  width: 6rem;

  ${({ theme }) => theme.media.mobile} {
    width: 4.5rem;
    height: 0.25rem;
  }
`;
